import { render, staticRenderFns } from "./partnerShipsAdd.vue?vue&type=template&id=4c15109b&scoped=true"
import script from "./partnerShipsAdd.vue?vue&type=script&lang=js"
export * from "./partnerShipsAdd.vue?vue&type=script&lang=js"
import style0 from "./partnerShipsAdd.vue?vue&type=style&index=0&id=4c15109b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c15109b",
  null
  
)

export default component.exports